import { sectionsPermissions } from "./interfaces/permissions";

export const permissions: sectionsPermissions = {
  client: [
    {
      id: "client-refeed",
      label: "clients.permissions.groups.items.client-refeed",
      permissions: ["view_refeed"],
      include_subclient: true,
      check: false
    },
    {
      id: "client-tests",
      label: "clients.permissions.groups.items.client-tests",
      permissions: ["view_automatic_test"],
      include_subclient: true,
      check: false
    },
    {
      id: "client-waterwise",
      label: "clients.permissions.groups.items.client-waterwise",
      permissions: ["view_waterwise", "change_waterwise"],
      include_subclient: true,
      check: false
    },
    {
      id: "client-speed",
      label: "clients.permissions.groups.items.client-speed",
      permissions: ["view_speed"],
      include_subclient: true,
      check: false
    },
    {
      id: "feeders-in-map",
      label: "clients.permissions.groups.items.feeders-in-map",
      permissions: ["view_feeder_in_map"],
      include_subclient: true,
      check: false
    },
    {
      id: "client-sweep",
      label: "clients.permissions.groups.items.client-sweep",
      permissions: ["sweep_testing"],
      include_subclient: true,
      check: false
    },
    {
      id: "nas",
      label: "clients.permissions.groups.items.nas",
      permissions: ["view_feedingfuzzylogic"],
      include_subclient: true,
      check: false
    },
    {
      id: "client-users",
      label: "clients.permissions.groups.items.client-users",
      permissions: ["view_userpermissions", "change_userpermissions"],
      include_subclient: true,
      check: false
    }
  ],
  view: [
    {
      id: "dashboard",
      label: "clients.permissions.groups.items.dashboard",
      permissions: ["view_dashboard"],
      check: false
    },
    {
      id: "granja",
      label: "clients.permissions.groups.items.granja",
      permissions: ["view_farms"],
      check: false
    },
    {
      id: "alertas",
      label: "clients.permissions.groups.items.alertas",
      permissions: ["view_alert"],
      check: false
    },
    {
      id: "dietas",
      label: "clients.permissions.groups.items.dietas",
      permissions: ["view_diets"],
      check: false
    },
    {
      id: "organigrama",
      label: "clients.permissions.groups.items.organigrama",
      permissions: ["view_userpermissions"],
      dependent: "client-users",
      check: false
    },
    {
      id: "biometrias",
      label: "clients.permissions.groups.items.biometrias",
      permissions: ["view_biometric"],
      check: false
    },
    {
      id: "view-waterwise",
      label: "clients.permissions.groups.items.view-waterwise",
      permissions: ["view_waterwise"],
      dependent: "client-waterwise",
      check: false
    },
    {
      id: "alimentacion",
      label: "clients.permissions.groups.items.alimentacion",
      permissions: ["view_feed"],
      check: false
    },
    {
      id: "ciclos",
      label: "clients.permissions.groups.items.ciclos",
      permissions: ["view_cycle"],
      check: false
    },
    {
      id: "charolas",
      label: "clients.permissions.groups.items.charolas",
      permissions: ["view_trayrecord"],
      check: false
    },
    {
      id: "parametrias",
      label: "clients.permissions.groups.items.parametrias",
      permissions: ["view_parametric"],
      check: false
    },
    {
      id: "cosechas",
      label: "clients.permissions.groups.items.cosechas",
      permissions: ["view_harvest"],
      check: false
    },
    {
      id: "tareas",
      label: "clients.permissions.groups.items.tareas",
      permissions: ["view_task"],
      check: false
    },
    {
      id: "clima",
      label: "clients.permissions.groups.items.clima",
      permissions: ["view_weather"],
      check: false
    },
    {
      id: "alimentadores",
      label: "clients.permissions.groups.items.alimentadores",
      permissions: ["view_feeder"],
      check: false
    },
    {
      id: "siembras",
      label: "clients.permissions.groups.items.siembras",
      permissions: ["view_plantings"],
      check: false
    },
    {
      id: "view-parametric-preference",
      label: "clients.permissions.groups.items.view-parametric-preference",
      permissions: ["view_parametricpreference"],
      check: false
    },
    {
      id: "view_sweep",
      label: "clients.permissions.groups.items.view_sweep",
      dependent: "client-sweep",
      permissions: ["sweep_testing"],
      check: false
    }
    /*  {
      id: "config",
      label: "Config. de umbrales",
      permissions: [],
      check: false,
    }, */
  ],
  control: [
    {
      id: "solicitar",
      label: "clients.permissions.groups.items.solicitar",
      permissions: ["change_alert"],
      check: false
    },
    {
      id: "control-waterwise",
      label: "clients.permissions.groups.items.control-waterwise",
      dependent: "client-waterwise",
      permissions: ["change_waterwise"],
      check: false
    },
    {
      id: "cosechas",
      label: "clients.permissions.groups.items.cosechas",
      permissions: ["change_harvest"],
      check: false
    },
    {
      id: "biometrias",
      label: "clients.permissions.groups.items.biometrias",
      permissions: ["change_biometric"],
      check: false
    },
    {
      id: "parametrias",
      label: "clients.permissions.groups.items.parametrias",
      permissions: ["change_parametric"],
      check: false
    },
    {
      id: "siembras",
      label: "clients.permissions.groups.items.siembras",
      permissions: ["change_plantings"],
      check: false
    },
    {
      id: "dietas",
      label: "clients.permissions.groups.items.dietas",
      permissions: ["change_diets"],
      check: false
    },
    {
      id: "tareas",
      label: "clients.permissions.groups.items.tareas",
      permissions: ["change_task"],
      check: false
    },
    {
      id: "alimentadores",
      label: "clients.permissions.groups.items.alimentadores",
      permissions: ["change_feeder"],
      check: false
    },
    {
      id: "control-reedistribucion",
      label: "clients.permissions.groups.items.control-reedistribucion",
      permissions: ["view_refeed"],
      dependent: "client-refeed",
      check: false
    },
    {
      id: "charolas",
      label: "clients.permissions.groups.items.charolas",
      permissions: ["change_trayrecord"],
      check: false
    },
    {
      id: "control-ciclos",
      label: "clients.permissions.groups.items.control-ciclos",
      permissions: ["change_cycle"],
      check: false
    },
    {
      id: "testeos",
      label: "clients.permissions.groups.items.testeos",
      permissions: ["view_automatic_test"],
      dependent: "client-tests",
      check: false
    },
    {
      id: "group",
      label: "clients.permissions.groups.items.group",
      permissions: ["change_userpermissions"],
      check: false
    },
    {
      id: "control-speed",
      label: "clients.permissions.groups.items.control-speed",
      permissions: ["view_speed"],
      dependent: "client-speed",
      check: false
    },

    {
      id: "control-parametric-preference",
      label: "clients.permissions.groups.items.control-parametric-preference",
      permissions: ["change_parametricpreference"],
      check: false
    },
    {
      id: "control-nas",
      label: "clients.permissions.groups.items.control-nas",
      permissions: ["view_feedingfuzzylogic"],
      dependent: "nas",
      check: false
    },
    {
      id: "alimentacion",
      label: "clients.permissions.groups.items.alimentacion",
      permissions: ["change_feed"],
      check: false
    }
    /*   {
      id: "config",
      label: "Config. de umbrales",
      permissions: [],
      check: false,
    }, */
  ]
};
